import CandidateListPage from './list/'
import CandidateAddPage from './add/'
import CandidateViewPage from './view/'

export default {
  CandidateListPage,
  CandidateViewPage,
  CandidateAddPage
}
